// 定义内容
export default {
  router: {
    home: 'home',
    system: 'system',
    systemMenu: 'systemMenu',
    systemRole: 'systemRole',
    systemUser: 'systemUser',
    systemDept: 'systemDept',
    systemDic: 'systemDic',
    limits: 'limits',
    limitsFrontEnd: 'FrontEnd',
    limitsFrontEndPage: 'FrontEndPage',
    limitsFrontEndBtn: 'FrontEndBtn',
    limitsBackEnd: 'BackEnd',
    limitsBackEndEndPage: 'BackEndEndPage',
    menu: 'menu',
    menu1: 'menu1',
    menu11: 'menu11',
    menu12: 'menu12',
    menu121: 'menu121',
    menu122: 'menu122',
    menu13: 'menu13',
    menu2: 'menu2',
    funIndex: 'function',
    funTagsView: 'funTagsView',
    funCountup: 'countup',
    funWangEditor: 'wangEditor',
    funCropper: 'cropper',
    funQrcode: 'qrcode',
    funEchartsMap: 'EchartsMap',
    funPrintJs: 'PrintJs',
    funClipboard: 'Copy cut',
    funGridLayout: 'Drag layout',
    funSplitpanes: 'Pane splitter',
    funDragVerify: 'Validator',
    pagesIndex: 'pages',
    pagesFiltering: 'Filtering',
    pagesFilteringDetails: 'FilteringDetails',
    pagesFilteringDetails1: 'FilteringDetails1',
    pagesIocnfont: 'iconfont icon',
    pagesElement: 'element icon',
    pagesAwesome: 'awesome icon',
    pagesFormAdapt: 'FormAdapt',
    pagesTableRules: 'pagesTableRules',
    pagesFormI18n: 'FormI18n',
    pagesFormRules: 'Multi form validation',
    pagesDynamicForm: 'Dynamic complex form',
    pagesWorkflow: 'Workflow',
    pagesListAdapt: 'ListAdapt',
    pagesWaterfall: 'Waterfall',
    pagesSteps: 'Steps',
    pagesPreview: 'Large preview',
    pagesWaves: 'Wave effect',
    pagesTree: 'tree alter table',
    pagesDrag: 'Drag command',
    pagesLazyImg: 'Image lazy loading',
    makeIndex: 'makeIndex',
    makeSelector: 'Icon selector',
    makeNoticeBar: 'notification bar',
    makeSvgDemo: 'Svgicon demo',
    makeTableDemo: 'table demo',
    paramsIndex: 'Routing parameters',
    paramsCommon: 'General routing',
    paramsDynamic: 'Dynamic routing',
    paramsCommonDetails: 'General routing details',
    paramsDynamicDetails: 'Dynamic routing details',
    chartIndex: 'chartIndex',
    visualizingIndex: 'visualizingIndex',
    visualizingLinkDemo1: 'visualizingLinkDemo1',
    visualizingLinkDemo2: 'visualizingLinkDemo2',
    personal: 'personal',
    tools: 'tools',
    layoutLinkView: 'LinkView',
    layoutIframeViewOne: 'IframeViewOne',
    layoutIframeViewTwo: 'IframeViewTwo',
  },
  staticRoutes: {
    signIn: 'signIn',
    notFound: 'notFound',
    noPower: 'noPower',
  },
  user: {
    title0: 'Component size',
    title1: 'Language switching',
    title2: 'Menu search',
    title3: 'Layout configuration',
    title4: 'news',
    title5: 'Full screen on',
    title6: 'Full screen off',
    dropdownLarge: 'large',
    dropdownDefault: 'default',
    dropdownSmall: 'small',
    dropdown1: 'home page',
    dropdown2: 'Personal Center',
    dropdown3: '404',
    dropdown4: '401',
    dropdown5: 'Log out',
    operdesc: 'Instructions',
    dropdown6: 'Code warehouse',
    changepwd: 'Change password',
    searchPlaceholder: 'Menu search: support Chinese, routing path',
    newTitle: 'notice',
    newBtn: 'All read',
    newGo: 'Go to the notification center',
    newDesc: 'No notice',
    logOutTitle: 'Tips',
    logOutMessage: 'This operation will log out. Do you want to continue?',
    logOutConfirm: 'determine',
    logOutCancel: 'cancel',
    logOutExit: 'Exiting',
  },
  tagsView: {
    refresh: 'refresh',
    close: 'close',
    closeOther: 'closeOther',
    closeAll: 'closeAll',
    fullscreen: 'fullscreen',
    closeFullscreen: 'closeFullscreen',
  },
  notFound: {
    foundTitle: 'Wrong address input, please re-enter the address~',
    foundMsg: 'You can check the web address first, and then re-enter or give us feedback.',
    foundBtn: 'Back to home page',
  },
  noAccess: {
    accessTitle: 'You are not authorized to operate~',
    accessMsg: 'Contact information: add QQ group discussion 665452019',
    accessBtn: 'Reauthorization',
  },
  layout: {
    configTitle: 'Layout configuration',
    oneTitle: 'Global Themes',
    twoTopTitle: 'top bar set up',
    twoMenuTitle: 'Menu set up',
    twoColumnsTitle: 'Columns set up',
    twoTopBar: 'Top bar background',
    twoTopTab: 'Top tab background',
    twoTopBarColor: 'Top bar default font color',
    twoIsTopBarColorGradual: 'Top bar gradient',
    twoIsTopTabColorGradual: 'Top tab gradient',
    twoMenuBar: 'Menu background',
    twoMenuBarColor: 'Menu default font color',
    twoMenuBarActiveColor: 'Menu Highlight Color',
    twoIsMenuBarColorGradual: 'Menu gradient',
    twoColumnsMenuBar: 'Column menu background',
    twoColumnsMenuBarColor: 'Default font color bar menu',
    twoIsColumnsMenuBarColorGradual: 'Column gradient',
    twoIsColumnsMenuHoverPreload: 'Column Menu Hover Preload',
    threeTitle: 'Interface settings',
    threeIsCollapse: 'Menu horizontal collapse',
    threeIsUniqueOpened: 'Menu accordion',
    threeIsFixedHeader: 'Fixed header',
    threeIsClassicSplitMenu: 'Classic layout split menu',
    threeIsLockScreen: 'Open the lock screen',
    threeLockScreenTime: 'screen locking(s/s)',
    fourTitle: 'Interface display',
    fourIsShowLogo: 'Sidebar logo',
    fourIsBreadcrumb: 'Open breadcrumb',
    fourIsBreadcrumbIcon: 'Open breadcrumb icon',
    fourIsTagsview: 'Open tagsview',
    fourIsTagsviewIcon: 'Open tagsview Icon',
    fourIsCacheTagsView: 'Enable tagsview cache',
    fourIsSortableTagsView: 'Enable tagsview drag',
    fourIsShareTagsView: 'Enable tagsview sharing',
    fourIsFooter: 'Open footer',
    fourIsGrayscale: 'Grey model',
    fourIsInvert: 'Color weak mode',
    fourIsDark: 'Dark Mode',
    fourIsWartermark: 'Turn on watermark',
    fourWartermarkText: 'Watermark copy',
    homeTitle: 'Home settings',
    fiveTitle: 'Other settings',
    theme: 'Theme',
    fiveTagsStyle: 'Tagsview style',
    fiveAnimation: 'page animation',
    fiveColumnsAsideStyle: 'Column style',
    fiveColumnsAsideLayout: 'Column layout',
    sixTitle: 'Layout switch',
    sixDefaults: 'One',
    sixClassic: 'Two',
    sixTransverse: 'Three',
    sixColumns: 'Four',
    tipText: 'Click the button below to copy the layout configuration to `/src/stores/themeConfig.ts` It has been modified in.',
    copyText: 'replication configuration',
    resetText: 'restore default',
    copyTextSuccess: 'Copy succeeded!',
    copyTextError: 'Copy failed!',
  },
  upgrade: {
    title: 'New version',
    msg: 'The new version is available, please update it now! Dont worry, the update is fast!',
    desc: 'Prompt: Update will restore the default configuration',
    btnOne: 'Cruel refusal',
    btnTwo: 'Update now',
    btnTwoLoading: 'Updating',
  },
};
